import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() {}

  generateExcel(data: any[], headers: string[], fileName: string): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Add headers
    worksheet.addRow(headers);

    headers.forEach((header, index) => {
      worksheet.getColumn(index + 1).width = 40; // Imposta la larghezza di ogni colonna a 40
    });

    // Define which headers correspond to date fields
    const dateColumns = ['dataInizioValidita', 'dataFineValidita']; // I nomi dei campi che contengono date
    // Add data
    data.forEach((item) => {
      const row: any = [];
      headers.forEach((header) => {
     
        let value = item[header];

        // If the header corresponds to a date field, convert it to a Date object
        if (dateColumns.includes(header) && value) {
          const dateParts = value.split('/'); // Divide la stringa con separatore '/'
          const year = parseInt(dateParts[0], 10);
          const month = parseInt(dateParts[1], 10) - 1; // I mesi in JS sono indicizzati da 0
          const day = parseInt(dateParts[2], 10);
          value = new Date(year, month, day);
 
        }
        if (header.includes(" ")) {
          value = item[header.replace(" ", "_")];
        }
        row.push(value);
      });
      worksheet.addRow(row);
    });

    // Apply 'yyyy-mm-dd' date format to the specific columns
    headers.forEach((header, index) => {
      if (dateColumns.includes(header)) {
        worksheet.getColumn(index + 1).eachCell({ includeEmpty: true }, (cell) => {
          if (cell.value instanceof Date) {
            cell.numFmt = 'yyyy-mm-dd'; // Formato data senza ora
          }
        });
      }
    });

    // Save the workbook to a blob
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${fileName}.xlsx`);
    });
  }
}

